@if (versionItemsJson !== '[]') {
<wp-dropdown
  [attr.show-label]="false"
  size="sm"
  mode="single"
  placeholder="Version"
  [attr.items]="versionItemsJson"
  [attr.values]="selectedVersionJson"
  (dropdownChange)="onVersionChange($event)">
</wp-dropdown>
}
